import React, { useEffect, useState } from "react";
import WaveSurfer from "wavesurfer.js";

export default function useWavesurfer(containerRef, url,sampleData) {
  const [wavesurfer, setWavesurfer] = useState(null);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const [data, setData]=useState([]);
  
  // Define the waveform gradient
  const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height * 1.5);
  gradient.addColorStop(0, "#656666"); // Top color
  gradient.addColorStop((canvas.height * 0.7) / canvas.height, "#656666"); // Top color
  gradient.addColorStop((canvas.height * 0.7 + 1) / canvas.height, "#ffffff"); // White line
  gradient.addColorStop((canvas.height * 0.7 + 2) / canvas.height, "#ffffff"); // White line
  gradient.addColorStop((canvas.height * 0.7 + 3) / canvas.height, "#B1B1B1"); // Bottom color
  gradient.addColorStop(1, "#B1B1B1"); // Bottom color

  // Define the progress gradient
  const progressGradient = ctx.createLinearGradient(
    0,
    0,
    0,
    canvas.height * 0.3
  );
  progressGradient.addColorStop(0, "#EE772F"); // Top color
  // progressGradient.addColorStop(
  //   (canvas.height * 0.8) / canvas.height,
  //   "#7C4DFF"
  // ); // Top color
  // progressGradient.addColorStop(
  //   (canvas.height * 0.7 + 1) / canvas.height,
  //   "#ffffff"
  // ); // White line
  // progressGradient.addColorStop(
  //   (canvas.height * 0.7 + 2) / canvas.height,
  //   "#ffffff"
  // ); // White line
  // progressGradient.addColorStop(
  //   (canvas.height * 0.7 + 3) / canvas.height,
  //   "#F6B094"
  // ); // Bottom color
  progressGradient.addColorStop(1, "#7C4DFF"); // Bottom color

  useEffect(() => {
    if (!containerRef.current) return;

    const ws = WaveSurfer.create({
      waveColor: gradient,
      progressColor: progressGradient,
      barWidth: 4,
      barGap: 5,
      barRadius: 8,
      height: 25,
      responsive: true,
      container: containerRef.current,
      backend: 'MediaElement'
    });

    setWavesurfer(ws);
    return () => {
      ws.destroy();
    };
  }, [containerRef,url]);

  useEffect(()=>{
    if(sampleData){
      const strippedString = sampleData.slice(1, -1);
      const resultArray = JSON.parse(`[${strippedString}]`);
      let arr=[];
      resultArray.forEach(element => {
        arr.push(element/100);
      });
      setData(arr);
    }
  },[sampleData])

  useEffect(() => {
		if (url && wavesurfer) {
      if(data.length===0){
        wavesurfer.load(url);
      }else{
        wavesurfer.load(url,data);
      }
		}
	}, [url, wavesurfer]);

  return wavesurfer;
}
